/// <reference lib="dom" />
export const WebSocket = globalThis.WebSocket;
export function isBrowserEnvironment() {
    return true;
}
export const useWebSocketProtocols = true;
//# sourceMappingURL=shims-browser.mjs.map